var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAward = function SvgAward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "m27.085 22.558 2.651 14.92a.875.875 0 0 1-1.418.822l-6.265-4.702a1.75 1.75 0 0 0-2.094 0l-6.276 4.7a.874.874 0 0 1-1.417-.82l2.65-14.92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M21 24.5c5.799 0 10.5-4.701 10.5-10.5S26.799 3.5 21 3.5 10.5 8.201 10.5 14 15.201 24.5 21 24.5"
  })));
};
export default SvgAward;